import { Controller } from "stimulus";

export default class extends Controller {
  static values = { itemId: Number, itemType: String };

  async add(event) {
    // Prevent the parent card <a> from navigating when interacting with the queue button.
    event.preventDefault();
    event.stopPropagation();

    // The server derives everything else from the episode; queue_client dispatches
    // supercast-queue-changed with the resulting snapshot.
    await window.queueClient.addToQueue({ itemId: this.itemIdValue, itemType: this.itemTypeValue });

    window.showToast("Added to queue");
  }
}
